import * as React from 'react';

import SignFieldTextInput16 from './SignFieldTextInput16';

export const signFieldTextInput16 = () => <SignFieldTextInput16 />;

export default {
    title: 'Icon/Fill/SignFieldTextInput16',
    component: SignFieldTextInput16,
    parameters: {
        notes: "`import SignFieldTextInput16 from 'box-ui-elements/es/icon/fill/SignFieldTextInput16';`",
    },
};
